/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q16Inputs */

const et_faq_q16 = /** @type {(inputs: Faq_Q16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis on konversiooni optimeerimine ja kuidas see suurendab müüki?`)
};

const en_faq_q16 = /** @type {(inputs: Faq_Q16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is conversion optimization and how does it increase sales?`)
};

/**
* | output |
* | --- |
* | "What is conversion optimization and how does it increase sales?" |
*
* @param {Faq_Q16Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q16 = /** @type {((inputs?: Faq_Q16Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q16Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q16(inputs)
	return en_faq_q16(inputs)
});